import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment } from '@angular/router';
import { AdminService } from "src/app/services/admin.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanLoad {

  constructor(
    private _adminService : AdminService,
    private _router : Router

  ){

  }

  canActivate(): any{
   if (!this.validateSession()) {
     this._router.navigate(['/login']);
      return false;
    }
    else{
      return true;
    } 
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    if (!this.validateSession()) {
      this._router.navigate(['/login']);
      return false;
    }

    return true;
  }

  private validateSession(): boolean {
    return this._adminService.isAuthenticated(['admin', 'asesor', 'cliente', 'propietario']);
  }
}
